import React from "react";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { CustomDialogProps } from "@mirage/contracts/CustomDialogProps";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export interface InformDialogProps extends CustomDialogProps {
    handleButtonClick?: () => void;
    icon?: IconDefinition;
    dialogActions?: JSX.Element;
}

const InformDialog: React.FC<InformDialogProps> = ({ open, mutation, handleButtonClick, header, dialogActions }) => {
    const headerText = typeof header === "string" ? header : null;
    const headerComponent = typeof header === "object" ? (header as JSX.Element) : null;
    return open ? (
        <Dialog maxWidth="md" open={open} className="">
            {headerText ? <DialogTitle className="">{headerText}</DialogTitle> : headerComponent}
            <DialogContent dividers className="">
                {getDialogContent()}
            </DialogContent>
            <DialogActions>
                {dialogActions ? (
                    dialogActions
                ) : (
                    <Button autoFocus onClick={handleButtonClick}>
                        Close
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    ) : null;

    function getDialogContent() {
        return (
            <>
                <Typography component="div" className="">
                    {mutation}
                </Typography>
            </>
        );
    }
};

export default InformDialog;
